import { BaseDialog } from 'src/components/BaseDialog/BaseDialog';
import { ts } from 'src/utils/translate';

interface LightingConfirmDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function LightingConfirmDialog({ open, onConfirm, onCancel }: LightingConfirmDialogProps) {
  return (
      <BaseDialog
          open={open}
          title={ts('p_lightcalc_confirm_title', 'Lighting calculation')}
          cancelLabel={ts('plt_cancel', 'Cancel')}
          actionLabel={ts('plt_ok', 'OK')}
          onAction={onConfirm}
          onClose={onCancel}
      >
        {ts('p_lightcalc_confirm', 'It may take a while to calculate the lighting. Would you like to start it?')}
      </BaseDialog>
  );
}
